module.exports = __webpack_public_path__ + "ec52f56c462f476b316adedc8d18d6d1.png";